import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AppTileService, IAppTileGroup } from './app-tile.svc';

@Component({
  selector: 'clp-appdash',
  templateUrl: './app-dash.comp.html',
  styles: [
    '.tile-group-container { display: flex; flex-direction: column; text-align: center;margin-top: 3rem; align-items: center; } ',
    '.tile-group-label { margin-bottom: 1rem; text-align: center; margin-left: auto; margin-right: auto; }',
    '.tile-group-separator { margin-bottom: 1.5rem; margin-top: 0.5rem; width: 25%; }',
    '.tile-container { display: flex; flex-grow: 1; justify-content: center; flex-wrap: wrap; gap: 2rem; margin-top: 1rem; }',
    '.tile { display:flex; width: 256px; height: 134px; }',
    '.tile > .btn.btn-link { flex-grow: 1 }',
    ':host { overflow: auto; padding-bottom: 1rem; }',
    '.jumbotron {background-color: #e9ecef;}'
  ],
  providers: [AppTileService]
})

export class AppDashComp implements OnInit {

  constructor(public tileSvc: AppTileService) {
    tileSvc.getVisibleGrouped().subscribe();
  }

  ngOnInit() { }

  public onHrefClick(url: string) {
    window.open(url, '_blank');
  }
}
